import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Chip } from './ihm-chip-list.interface';

@Component({
  selector: 'ihm-chip-list',
  templateUrl: './ihm-chip-list.component.html',
  styleUrls: ['./ihm-chip-list.component.scss']
})
export class IhmChipListComponent {
  @ViewChild('chipList', { static: true }) chipList: ElementRef;

  @Input() readonly itemList: Chip[] = [];
  @Input() readonly removableChips: boolean = true;
  @Input() readonly maxHeight: number = 75;
  @Output() readonly removeItem: EventEmitter<Chip> = new EventEmitter();

  chipListIsOverMaxHeight(): boolean {
    return this.chipList.nativeElement.offsetHeight > this.maxHeight;
  }

  removeChip(item: Chip): void {
    this.removeItem.emit(item);
  }
}
